export const adviceStudent = [
   {
     boldTitle: "Занурення:",
     text: "Пориньте в мовне середовище. Слухайте музику, дивіться фільми та серіали, читайте книги та новини мовою, яку вивчаєте. На ваших уроках ви знайдете все необхідне для цього.",
   },
   {
     boldTitle: "Практика спілкування:",
     text: "Використовуйте можливості спілкування з викладачами, щоб покращити вимову та розуміння розмовної мови.",
   },
   {
     boldTitle: "Щоденна практика:",
     text: "Виділяйте хоча б 15-30 хвилин щодня на вивчення мови. Регулярність допомагає краще засвоювати новий матеріал.",
   },
   {
     boldTitle: "Граматика та лексика:",
     text: "Працюйте над граматикою та лексикою паралельно. На ваших уроках у Speaksy ви знайдете структуровані курси з граматики та лексичний матеріал.",
   },
   {
     boldTitle: "Встановлення цілей:",
     text: "Встановлюйте конкретні, досяжні цілі для вивчення мови. На платформі  ви можете відстежувати свій прогрес і бачити свої досягнення.",
   },
   {
     boldTitle: "Культурний контекст:",
     text: "Дізнавайтеся більше про країни, де говорять цією мовою, та їхню культуру на ваших уроках. Це допоможе вам краще розуміти контексти використання певних фраз та виразів.",
   },
];

export const rules = [
   {
      boldTitle: "Скасування/Перенесення Уроку:",
      text: "Скасувати/Перенести урок ви можете на сторінці 'Розклад'",
    },
    {
      boldTitle: "Заміна Вчителя:",
      text: "У випадку відміни уроку викладачем, ми забезпечимо заміну викладача, або перенесемо урок на інший зручний для всіх день. Якщо вам не підходить викладач — напишіть менеджеру, і ми підберемо іншого.",
    },
    {
      boldTitle: "Скасування Уроку та Відшкодування:",
      text: "Прохання скасовувати уроки щонайменше за 4 години до початку. В іншому випадку урок вважатиметься пройденим, за винятком непередбачуваних ситуацій. У разі бажання учня завершити навчання в нашій школі, проте залишаються оплачені уроки, варто зазначити, що гроші за залишкові уроки не підлягають поверненню. Однак у вас є можливість призупинити навчання.",
    },
    {
      boldTitle: "Пауза:",
      text: "Повернутися з паузи можна в будь-який час — невикористані уроки залишаються на балансі. Під час паузи ми не гарантуємо, що за вами збережуться той самий викладач і час, але гарантуємо викладача після повернення — того самого, якщо він вільний, або нового.",
    },
    {
      boldTitle: "Запізнення та Відсутність Вчителя:",
      text: "Запізнення учня на урок не компенсується часом. У випадку відсутності вчителя без попередження, пропущений урок буде перенесений на інший зручний для вас час.",
    },
    {
      boldTitle: "Акція 'Приведи Друга':",
      text: "У нашій школі діє акція 'Приведи Друга'. Якщо друг за вашим посиланням оплатить перший пакет уроків, ви обидва отримаєте по 2 безкоштовні уроки.",
    },
    {
      boldTitle: "Тривалість уроків:",
      text: "Учні до 12років - 45хв., 12+ років - 50хв.",
    },
    {
      boldTitle: "Технічна рекомендація:",
      text: "Рекомендуємо приєднуватись до уроків з ноутбука або комп'ютера. Якщо у вас Windows — бажано використовувати останню версію системи. Якщо Mac — також останню версію macOS. Рекомендуємо використовувати виключно браузер Google Chrome для найкращої якості зв'язку та стабільності.",
    }

]

export const newFeatureTitleStudent = "Зірки та магазин нагород"

export const newFeatureStudent = [
  {
    number: '1',
    text: 'За кожне здане домашнє завдання ти отримуєш зірку. Баланс видно вгорі сторінки.'
  },
  {
    number: '2',
    text: 'Обмінюй зірки в магазині на знижку на пакет або безкоштовний урок.'
  },
  {
    number: '3',
    text: 'Подаруй другу пробний урок із магазину — якщо він купить пакет, ти отримаєш ще 20 зірок.'
  },
]
